import React from 'react';

const MaintenanceMessage = ({ message }) => {
    return <div className="alert alert-warning" role="alert">{message}</div>
};

export default MaintenanceMessage;
